import SEO from "../../components/SEO";
import { BsEnvelope, BsPhone, BsGeoAlt, BsClock } from "react-icons/bs";

export const ContactPage = () => {
	return (
		<div className="w-full min-h-screen bg-gradient-to-br from-cyan-100 to-fuchsia-200 py-12 px-5"><SEO title="Contact Us" description="Get in touch with Parcelin. Email support@parcelin.co.za or call 069 904 2846. We serve Gauteng and Limpopo." path="/contact" />
			<div className="max-w-6xl mx-auto">
				<div className="text-center mb-12">
					<h1 className="text-4xl md:text-5xl font-bold text-purple-800 mb-4">Get In Touch</h1>
					<p className="text-lg text-gray-700">We're here to help with any questions or concerns</p>
				</div>

				<div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
					{/* Contact Information */}
					<div className="space-y-6">
						<div className="bg-white rounded-xl shadow-lg p-8">
							<h2 className="text-2xl font-bold text-purple-800 mb-6">Contact Information</h2>
							
							<div className="space-y-6">
								<div className="flex items-start gap-4">
									<BsEnvelope className="text-purple-600 text-2xl flex-shrink-0 mt-1" />
									<div>
										<h3 className="font-semibold text-gray-800 mb-1">Email</h3>
										<a href="mailto:support@parcelin.co.za" className="text-purple-600 hover:text-purple-700">
											support@parcelin.co.za
										</a>
									</div>
								</div>

								<div className="flex items-start gap-4">
									<BsPhone className="text-purple-600 text-2xl flex-shrink-0 mt-1" />
									<div>
										<h3 className="font-semibold text-gray-800 mb-1">Phone</h3>
										<a href="tel:0699042846" className="text-purple-600 hover:text-purple-700">
											069 904 2846
										</a>
									</div>
								</div>

								<div className="flex items-start gap-4">
									<BsGeoAlt className="text-purple-600 text-2xl flex-shrink-0 mt-1" />
									<div>
										<h3 className="font-semibold text-gray-800 mb-1">Service Areas</h3>
										<p className="text-gray-700">
											Limpopo: Polokwane, Giyani, Malamulele, Tzaneen, Bungeni, Thohoyandou, Phalaborwa<br />
											Gauteng: 80KM radius of Midrand
										</p>
									</div>
								</div>

								<div className="flex items-start gap-4">
									<BsClock className="text-purple-600 text-2xl flex-shrink-0 mt-1" />
									<div>
										<h3 className="font-semibold text-gray-800 mb-1">Support Hours</h3>
										<p className="text-gray-700">
											Monday - Friday: 8:00 AM - 6:00 PM<br />
											Saturday: 9:00 AM - 2:00 PM<br />
											Sunday: Closed
										</p>
									</div>
								</div>
							</div>
						</div>

						<div className="bg-gradient-to-br from-purple-600 to-fuchsia-600 rounded-xl shadow-lg p-8 text-white">
							<h2 className="text-2xl font-bold mb-4">Need Immediate Help?</h2>
							<p className="mb-6">
								For urgent delivery issues or questions about your parcel, please call us directly or check your parcel status using your tracking number.
							</p>
							<a href="/track_parcel" className="inline-block bg-white text-purple-600 px-6 py-3 rounded-full font-semibold hover:bg-gray-100 transition-colors">
								Track Your Parcel
							</a>
						</div>
					</div>

					{/* Contact Form */}
					<div className="bg-white rounded-xl shadow-lg p-8">
						<h2 className="text-2xl font-bold text-purple-800 mb-6">Send Us a Message</h2>
						
						<form className="space-y-4">
							<div>
								<label htmlFor="name" className="block text-gray-700 font-semibold mb-2">
									Full Name *
								</label>
								<input
									type="text"
									id="name"
									name="name"
									required
									className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:border-purple-500"
									placeholder="Your name"
								/>
							</div>

							<div>
								<label htmlFor="email" className="block text-gray-700 font-semibold mb-2">
									Email Address *
								</label>
								<input
									type="email"
									id="email"
									name="email"
									required
									className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:border-purple-500"
									placeholder="your.email@example.com"
								/>
							</div>

							<div>
								<label htmlFor="phone" className="block text-gray-700 font-semibold mb-2">
									Phone Number
								</label>
								<input
									type="tel"
									id="phone"
									name="phone"
									className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:border-purple-500"
									placeholder="069 123 4567"
								/>
							</div>

							<div>
								<label htmlFor="subject" className="block text-gray-700 font-semibold mb-2">
									Subject *
								</label>
								<select
									id="subject"
									name="subject"
									required
									className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:border-purple-500"
								>
									<option value="">Select a subject</option>
									<option value="general">General Inquiry</option>
									<option value="booking">Booking Question</option>
									<option value="tracking">Tracking Issue</option>
									<option value="payment">Payment Question</option>
									<option value="driver">Become a Driver</option>
									<option value="feedback">Feedback</option>
									<option value="other">Other</option>
								</select>
							</div>

							<div>
								<label htmlFor="message" className="block text-gray-700 font-semibold mb-2">
									Message *
								</label>
								<textarea
									id="message"
									name="message"
									required
									rows="5"
									className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:border-purple-500"
									placeholder="Tell us how we can help..."
								></textarea>
							</div>

							<button
								type="submit"
								className="w-full bg-purple-600 text-white py-3 rounded-lg font-semibold hover:bg-purple-700 transition-colors"
							>
								Send Message
							</button>
						</form>
					</div>
				</div>

				{/* FAQ Link */}
				<div className="mt-12 text-center bg-white rounded-xl p-8 shadow-lg">
					<h2 className="text-2xl font-bold text-purple-800 mb-4">Looking for Quick Answers?</h2>
					<p className="text-gray-700 mb-6">Check out our FAQ page for answers to common questions.</p>
					<a href="/faq" className="inline-block bg-purple-600 text-white px-8 py-3 rounded-full hover:bg-purple-700 transition-colors">
						View FAQ
					</a>
				</div>
			</div>
		</div>
	);
};
